import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {ReportSettingTemplate} from "../models/report.model";

@Injectable({
  providedIn: 'root'
})
export class ReportSettingTemplateService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}


  get(): Observable<ReportSettingTemplate[]>{
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + 'reportTemplate/getList/')
      .pipe(map(reportTemplates => reportTemplates.map(reportTemplate => {
        return {
          ...reportTemplate,
          settings: JSON.parse(reportTemplate.settings)
        }
      })));
  }

  create(reportTemplateSettings): Observable<any>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'reportTemplate/create/', reportTemplateSettings)
      .pipe(map(reportTemplate => {
        const templateData = reportTemplate.data;
        return {
          ...templateData,
          settings: JSON.parse(templateData.settings)
        }
      }));
  }

  modify(reportTemplateSettings): Observable<any>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'reportTemplate/modify/', reportTemplateSettings)
      .pipe(map(reportTemplate => {
        const templateData = reportTemplate.data;
        return {
          ...templateData,
          settings: JSON.parse(templateData.settings)
        }
      }));
  }

  remove(reportSettingTemplateId: string): Observable<any>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `reportTemplate/delete/${reportSettingTemplateId}`);
  }
}
